import { render, staticRenderFns } from "./CallFeeOverviewList.vue?vue&type=template&id=0c74f821"
import script from "./CallFeeOverviewList.vue?vue&type=script&lang=js"
export * from "./CallFeeOverviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports